import type { SoftwareAssuranceWorkflowController } from '@/hooks/workflow/useSoftwareAssuranceWorkflow'

import { CategorizationStepSection } from './CategorizationStepSection'
import { IntegrationsStepSection } from './IntegrationsStepSection'
import { MissionStepSection } from './MissionStepSection'
import { ProfileStepSection } from './ProfileStepSection'
import { ReportStepSection } from './ReportStepSection'
import { ReviewStepSection } from './ReviewStepSection'
import { ScansStepSection } from './ScansStepSection'
import { ScoringStepSection } from './ScoringStepSection'
import { SourcesStepSection } from './SourcesStepSection'
import { StigsStepSection } from './StigsStepSection'
import { ToolingStepSection } from './ToolingStepSection'

interface WorkflowStepContentProps {
  workflow: SoftwareAssuranceWorkflowController
}

export function WorkflowStepContent({ workflow }: WorkflowStepContentProps) {
  switch (workflow.current?.id) {
    case 'mission':
      return <MissionStepSection workflow={workflow} />
    case 'profile':
      return <ProfileStepSection workflow={workflow} />
    case 'categorization':
      return <CategorizationStepSection workflow={workflow} />
    case 'stigs':
      return <StigsStepSection />
    case 'sources':
      return <SourcesStepSection workflow={workflow} />
    case 'integrations':
      return <IntegrationsStepSection workflow={workflow} />
    case 'tooling':
      return <ToolingStepSection workflow={workflow} />
    case 'scans':
      return <ScansStepSection workflow={workflow} />
    case 'review':
      return <ReviewStepSection workflow={workflow} />
    case 'scoring':
      return <ScoringStepSection workflow={workflow} />
    case 'report':
      return <ReportStepSection workflow={workflow} />
    default:
      return <p className="text-sm text-muted-foreground">Select a workflow step to continue.</p>
  }
}
